(function () {
  'use strict';

  function sharpen(img) {
    var hires = img.getAttribute('data-hires');
    if (!hires) return;
    var probe = new Image();
    probe.onload = function () {
      if (probe.naturalWidth > 320) img.src = hires;
    };
    probe.src = hires;
  }

  function play(button) {
    var id = button.getAttribute('data-video-embed');
    if (!id) return;
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    frame.title = button.getAttribute('aria-label') || 'YouTube video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.className = 'about-video__frame';
    button.parentNode.replaceChild(frame, button);
    frame.focus();
  }

  function init(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-video-embed] img[data-hires]'), sharpen);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-video-embed]');
    if (button) play(button);
  });

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
